import { render, staticRenderFns } from "./MasterdataForecastsDeleteModal.vue?vue&type=template&id=b2773cba"
import script from "./MasterdataForecastsDeleteModal.vue?vue&type=script&lang=js"
export * from "./MasterdataForecastsDeleteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports